import { forwardRef, useContext } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import composeRefs from '@seznam/compose-react-refs';

import { MenuTriggerContext } from '@components/primitives/Menu/context';

export const MenuTrigger = forwardRef<
  HTMLButtonElement,
  DropdownMenu.DropdownMenuTriggerProps
>(function MenuTrigger(props, ref) {
  const contextRef = useContext(MenuTriggerContext);
  return (
    <DropdownMenu.Trigger
      ref={composeRefs(ref, contextRef)}
      asChild
      {...props}
    />
  );
});
